import * as types from 'store/modules/hres8ax/mutation-types'
import hres8axLabels from 'assets/labels/hres8ax'
import { hres8axColumns } from 'assets/columns/hres8ax'
import configLabel from 'src/../config/label'
import hres8ax from 'api/hres8ax'
import swal from 'sweetalert'
// import axios from 'axios'

export default {
  state: {
    labels: hres8axLabels,
    columns: hres8axColumns(),
    indexSelected: {},
    detailIndex: {},
    detail: {
      salary: {},
      deduction: {
        table1: {
          total: 0,
          rows: []
        },
        table2: {
          total: 0,
          rows: []
        }
      },
      invest: {
        amtD10: 0,
        amtD11: 0,
        amtD12: 0,
        amtD13: 0,
        codD10: '',
        codD11: '',
        codD12: '',
        codD13: ''
      },
      caltax: {}
    },
    detailDeductionSelected: {},
    popupDetailDeduction: {}
  },
  getters: {
    [types.GET_HRES8AX_COLUMNS] (state) {
      return state.columns
    },
    [types.GET_HRES8AX_LABELS] (state) {
      return state.labels
    },
    [types.GET_HRES8AX_DETAIL_DEDUCTION_SELECTED] (state) {
      return state.detailDeductionSelected
    },
    [types.GET_HRES8AX_DETAIL_INDEX] (state) {
      return state.detailIndex
    },
    [types.GET_HRES8AX_DETAIL_SALARY] (state) {
      return state.detail.salary
    },
    [types.GET_HRES8AX_DETAIL_DEDUCTION] (state) {
      return state.detail.deduction
    },
    [types.GET_HRES8AX_DETAIL_INVEST] (state) {
      return state.detail.invest
    },
    [types.GET_HRES8AX_DETAIL_CALTAX] (state) {
      return state.detail.caltax
    },
    [types.GET_HRES8AX_DETAIL_DEDUCTION_POPUP] (state) {
      return state.popupDetailDeduction
    }
  },
  mutations: {
    [types.SET_HRES8AX_COLUMNS] (state, labels) {
      for (var keyLang of configLabel.allLang) {
        state.columns[keyLang].detailDeductionTable1 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailDeductionTable1, labels[keyLang])
        state.columns[keyLang].detailDeductionTable2 = configLabel.replaceLabelToColumns(state.columns[keyLang].detailDeductionTable2, labels[keyLang])
      }
    },
    [types.SET_HRES8AX_LABELS] (state, labels) {
      state.labels.en = labels.en
      state.labels.th = labels.th
    },
    [types.SET_HRES8AX_DETAIL_DEDUCTION_SELECTED] (state, detailDeductionSelected) {
      state.detailDeductionSelected = detailDeductionSelected
    },
    [types.SET_HRES8AX_DETAIL_INDEX] (state, data) {
      state.detailIndex = data
    },
    [types.SET_HRES8AX_DETAIL_SALARY] (state, data) {
      state.detail.salary = data
    },
    [types.SET_HRES8AX_DETAIL_DEDUCTION] (state, data) {
      state.detail.deduction = data
    },
    [types.SET_HRES8AX_DETAIL_INVEST] (state, data) {
      let coddeducts = [ 'D10', 'D11', 'D12', 'D13' ]
      for (let coddeduct of coddeducts) {
        let dataRowsFiltered = data.rows.filter((dataRow) => {
          return dataRow.coddeduct === coddeduct
        })
        state.detail.invest['cod' + coddeduct] = coddeduct
        state.detail.invest['amt' + coddeduct] = (dataRowsFiltered[0]) ? dataRowsFiltered[0].amtdeduct : ''
      }
    },
    [types.SET_HRES8AX_DETAIL_CALTAX] (state, data) {
      state.detail.caltax = data
    },
    [types.SET_HRES8AX_DETAIL_DEDUCTION_POPUP] (state, popupDetailDeduction) {
      state.popupDetailDeduction = popupDetailDeduction
    }
  },
  actions: {
    [types.RECEIVED_HRES8AX_COLUMNS_LABELS] ({ commit }) {
      hres8ax.getLabels()
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES8AX_COLUMNS, data.labels)
          commit(types.SET_HRES8AX_LABELS, data.labels)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES8AX_DETAIL_INDEX] ({ commit }, detailParams) {
      hres8ax.getDetailIndex(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES8AX_DETAIL_INDEX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES8AX_DETAIL_SALARY] ({ commit }, detailParams) {
      hres8ax.getDetailSalary(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES8AX_DETAIL_SALARY, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES8AX_DETAIL_DEDUCTION] ({ commit }, detailParams) {
      hres8ax.getDetailDeduction(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES8AX_DETAIL_DEDUCTION, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES8AX_DETAIL_INVEST] ({ commit }, detailParams) {
      hres8ax.getDetailInvest(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES8AX_DETAIL_INVEST, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES8AX_DETAIL_CALTAX] ({ commit }, detailParams) {
      hres8ax.getDetailCaltax(detailParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES8AX_DETAIL_CALTAX, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.RECEIVED_HRES8AX_DETAIL_DEDUCTION_POPUP] ({ commit }, popupParams) {
      hres8ax.getPopupDetailDeduction(popupParams)
        .then((response) => {
          const data = JSON.parse(response.request.response)
          commit(types.SET_HRES8AX_DETAIL_DEDUCTION_POPUP, data)
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.SAVE_HRES8AX_SALARY_SAVE] ({ commit, dispatch }, { detailParams, detailSalary, targetPage }) {
      hres8ax.saveDetailSalary({ detailParams, detailSalary })
        .then((response) => {
          if (parseInt(targetPage) === 4) {
            dispatch(types.RECEIVED_HRES8AX_DETAIL_CALTAX, { dteyrepay: detailParams.dteyrepay })
          }
          // const data = JSON.parse(response.request.response)
          // swal({
          //   title: '', text: data.response, html: true, type: 'success'
          // }, function () {
          //   window.onkeydown = null; window.onfocus = null; swal('')
          // })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.SAVE_HRES8AX_DEDUCTION_SAVE] ({ commit, dispatch }, { detailParams, detailDeduction, targetPage }) {
      hres8ax.saveDetailDeduction({ detailParams, detailDeduction })
        .then((response) => {
          if (parseInt(targetPage) === 4) {
            dispatch(types.RECEIVED_HRES8AX_DETAIL_CALTAX, { dteyrepay: detailParams.dteyrepay })
          }
          // const data = JSON.parse(response.request.response)
          // swal({
          //   title: '', text: data.response, html: true, type: 'success'
          // }, function () {
          //   window.onkeydown = null; window.onfocus = null; swal('')
          // })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    },
    [types.SAVE_HRES8AX_INVEST_SAVE] ({ commit, dispatch }, { detailParams, detailInvest, targetPage }) {
      hres8ax.saveDetailInvest({ detailParams, detailInvest })
        .then((response) => {
          if (parseInt(targetPage) === 4) {
            dispatch(types.RECEIVED_HRES8AX_DETAIL_CALTAX, { dteyrepay: detailParams.dteyrepay })
          }
          // const data = JSON.parse(response.request.response)
          // swal({
          //   title: '', text: data.response, html: true, type: 'success'
          // }, function () {
          //   window.onkeydown = null; window.onfocus = null; swal('')
          // })
        })
        .catch((error) => {
          let message = error
          if (error.response) {
            const data = error.response.data
            message = data.response
          }
          swal({
            title: '', text: message, html: true, type: 'error'
          }, function () {
            window.onkeydown = null; window.onfocus = null; swal('')
          })
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/hres8ax/index.js